import { Ticket } from "callable-data-objects";
import React from "react";
import { Label } from "semantic-ui-react";

type TicketTypeLabelProps = {
  ticket: Ticket;
};
const TicketTypeLabel = ({ ticket }: TicketTypeLabelProps) => {
  switch (ticket.type) {
    case "assignment-request":
      return (
        <Label as='a' color='blue' tag>
          Assignment
        </Label>
      );
    case "port-request":
      return (
        <Label as='a' color='green' tag>
          Porting
        </Label>
      );
    case "export-request":
      return (
        <Label as='a' color='red' tag>
          Export
        </Label>
      );
    case "migration-request":
      return (
        <Label as='a' color='orange' tag>
          Migration
        </Label>
      );
    case "allocation-request":
      return (
        <Label as='a' color='purple' tag>
          Allocation
        </Label>
      );
    case "global-number-request":
      return (
        <Label as='a' color='brown' tag>
          Global Number
        </Label>
      );
  }
  throw new Error("Unknown ticket type = " + ticket.type);
};

export default TicketTypeLabel;
